import { useKeyboard } from '@react-aria/interactions';
export const useEnter = (fn) => {
    const result = useKeyboard({
        onKeyDown(e) {
            if (e.key === 'Enter') {
                fn(e);
            }
        },
    });
    return { onKeyDown: result.keyboardProps.onKeyDown };
};
//# sourceMappingURL=useEnter.js.map